<template>
  <v-btn icon @click="$emit('help')" small>
    <v-icon color='white'>mdi-help-circle-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'help-toolbar-icon'
}
</script>
